import { blue } from "../colors/index.js";
const infoColor = (mode)=>'light' === mode ? {
        main: blue["500"],
        highContrast: blue["700"],
        lowContrast: blue["100"]
    } : {
        main: blue["400"],
        highContrast: blue["100"],
        lowContrast: blue["800"]
    };
export { infoColor };

//# sourceMappingURL=info.js.map